import React, { FunctionComponent, useEffect } from 'react'
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Hint } from "@progress/kendo-react-labels";
import { FieldRenderProps } from '@progress/kendo-react-form';

const NumericField: FunctionComponent<FieldRenderProps> = formRenderProps => {
    const { field } = formRenderProps;

    let format = "n" + field.ConfigSettings?.Decimal;
    if (field.Field_Type_Id === 9) { format = "c2" } //Currency
    //if(field.Field_Type_Id === 5)
    const minVal = field.ConfigSettings?.MinValue || undefined;
    const maxVal = field.ConfigSettings?.MaxValue || 2147483647;
    const currentValue = field?.VALUES?.length > 0 ? field.VALUES[0] : undefined;
    const [value, setValue] = React.useState(null)
    useEffect(() => {
        setValue(currentValue);
    }, [currentValue]);
    const handleChange = (e) => {

        setValue(e.value);
    };
    const onBlur = (e) => {
        console.log(e.target.value);
        let fieldChange = { ...field, VALUES: e.target.value ? [e.target.value] : [0] }
        formRenderProps.onChange({ value: fieldChange });
    }
    return (
        <>
            {/* default:{minVal} - {maxVal} - {format} */}
            <NumericTextBox value={value || ''} onChange={handleChange} onBlur={onBlur} spinners={false} format={format} min={minVal} max={maxVal} />
            {minVal && maxVal &&
                <Hint direction={"end"}>
                    range {minVal} - {maxVal}
                </Hint>
            }
        </>
    )
}

export default NumericField;